<mat-card>
    <img mat-card-image
         src="{{getProductImageUrl()}}"
	/>
    <img class="cat-flag"
		*ngIf="isMemotainProduct()"
         src="{{getMemotainCategoryImageUrl()}}"
	/>

    <mat-card-content>
        <h3 [innerHTML]="getProductNameHtml()" data-cy="product-visual-product-name"></h3>

        <p *ngIf="!isProfessionalProduct()">
            {{getProductDescription()}}
        </p>

		@if(isDisplayedDuringOrder){
			@if(isProfessionalProduct()){
				 <!-- image for tooth area visualization for professional (including package size etc.)-->
				 <img src="{{getToothAreaImageUrl()}}" data-cy="professional-tooth-area-image">
			}
		}@else{
			@if( options ){
				 <!-- tootharea images-->
				 <div class="toothAreas" data-cy="product-visual-tooth-areas">
					 <div class="jaws" [ngClass]="{'two-jaws': options.uj && options.lj}">
						<div class="jaw" *ngIf="options.uj && getToothAreaForProduct(true) as toothArea">
							<img src="assets/img/options/uj_{{toothArea}}.png"/>
							<div data-cy="product-visual-tooth-area-uj">{{toothArea}}</div>
						</div>
						<div class="jaw" *ngIf="options.lj && getToothAreaForProduct(false) as toothArea">
							<img  src="assets/img/options/lj_{{toothArea}}.png"/>
							<div data-cy="product-visual-tooth-area-lj">{{toothArea}}</div>
						</div>
					</div>
				</div>
			}
		}

    </mat-card-content>
</mat-card>
